import util from '../util'

let controller = 'CNAB'
export default {
  GetArquivoRetornoCNAB240: (dto) => {
    return util.Axios.GetAll(controller + '/240', dto)
  },
  PostCNAB: function (dto) {
    return util.Axios.PostForm(controller + '/240/Importar', dto)
  },
  DownloadCNAB: function (cnabDto) {
    return util.Axios.GetBlob(controller + '/Download', cnabDto)
  },
  GetHistoricoLogs: (dto, options) => {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/HistoricoLogs', dto)
  },
   ValidarCNAB: function (dto) {
    return util.Axios.PostForm(controller + '/240/Validar', dto)
  },
  InterpretarCNAB: function (dto) {
    return util.Axios.PostForm(controller + '/240/Interpretar', dto)
  }
}
